"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Email = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const utils_1 = require("./utils");
function obfuscateEmail(email) {
    const [username, domain] = email.split("@");
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", { dangerouslySetInnerHTML: {
                __html: `
          a>span.roe::after {
            content: "@";
          }
        `,
            } }),
        username,
        react_1.default.createElement("span", { className: "roe" }),
        domain));
}
function Email(_a) {
    var { bcc = [], body = "", cc = [], children, email, subject = "" } = _a, props = tslib_1.__rest(_a, ["bcc", "body", "cc", "children", "email", "subject"]);
    const [hovered, setHovered] = (0, react_1.useState)(false);
    const emailUrl = new URL(`mailto:${email}`);
    emailUrl.search = (0, utils_1.percentEncodeParams)({ bcc, body, cc, subject });
    function handleHover() {
        setHovered(true);
    }
    const displayText = children || email;
    const obfuscatedText = children || obfuscateEmail(email);
    return (react_1.default.createElement("a", Object.assign({ href: hovered ? emailUrl.href : "#", onFocus: handleHover, onMouseOver: handleHover }, props), hovered ? displayText : obfuscatedText));
}
exports.Email = Email;
